import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { FileCheck, Gauge, Search, Lightbulb } from 'lucide-react';

const iconMap = {
  FileCheck,
  Gauge,
  Search,
  Lightbulb
};

const colorMap = {
  FileCheck: { bg: 'bg-blue-100', icon: 'text-blue-600', hoverBg: 'group-hover:bg-blue-600', border: 'hover:border-blue-300' },
  Gauge: { bg: 'bg-red-100', icon: 'text-red-600', hoverBg: 'group-hover:bg-red-600', border: 'hover:border-red-300' },
  Search: { bg: 'bg-blue-100', icon: 'text-blue-600', hoverBg: 'group-hover:bg-blue-600', border: 'hover:border-blue-300' },
  Lightbulb: { bg: 'bg-red-100', icon: 'text-red-600', hoverBg: 'group-hover:bg-red-600', border: 'hover:border-red-300' }
};

export const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon] || FileCheck;
  const colors = colorMap[service.icon] || colorMap.FileCheck;
  
  return (
    <Card className={`service-card group hover:shadow-xl transition-all duration-300 border-2 ${colors.border}`}>
      <CardHeader>
        <div className={`w-14 h-14 ${colors.bg} rounded-lg flex items-center justify-center mb-4 ${colors.hoverBg} transition-colors duration-300`}>
          <IconComponent className={`w-7 h-7 ${colors.icon} group-hover:text-white transition-colors duration-300`} />
        </div>
        <CardTitle className="text-xl font-semibold text-slate-800">{service.title}</CardTitle>
        <CardDescription className="text-slate-600 leading-relaxed">
          {service.description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {service.features.map((feature, idx) => (
            <li key={idx} className="flex items-center text-sm text-slate-700">
              <span className={`w-1.5 h-1.5 ${idx % 2 === 0 ? 'bg-blue-600' : 'bg-red-600'} rounded-full mr-2`}></span>
              {feature}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
